import React from "react";
import Card from "../common/Card";
import Icon from "../common/Icon";
import Tooltip from "./Tooltip";
import "./KPICard.css";

const KPICard = ({
  icon,
  label,
  value,
  iconColor = "var(--color-primary)",
  tooltipText,
}) => {
  return (
    <Card className="kpi-card" hover>
      <div className="kpi-header">
        {tooltipText ? (
          <Tooltip text={tooltipText}>
            <div className="kpi-label-container">
              <h3 className="kpi-label">{label}</h3>
              <Icon name="Info" size={14} className="kpi-info-icon" />
            </div>
          </Tooltip>
        ) : (
          <h3 className="kpi-label">{label}</h3>
        )}
        <div className="kpi-icon" style={{ color: iconColor }}>
          <Icon name={icon} size={24} />
        </div>
      </div>
      <p className="kpi-value">{value}</p>
    </Card>
  );
};

export default KPICard;
